import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import {
  bgColor11,
  bgColor15,
  blackShade19,
  blueColor04,
  greenStatusColor01,
  greyColor060,
  lightgreenColor04,
  lightOrange04,
  logoImgborder1,
  orangeColor03,
  orderCardBorder,
  perpleBgColor11,
  redColor09,
  redStatusColor01,
  whiteColor,
} from "../../configs/styles/muiThemes";
import {
  addThousandsSeparator,
  getDiscountPercentage,
} from "../../utils/helper";

function ProductDetailCatalogReport({ item, handleViewChildVariants }) {
  console.log("item", item);

  return (
    <Box sx={styles.card}>
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={6} md={4}>
          <Box display={"flex"} alignItems={"center"} gap={2}>
            <Box
              component="img"
              alt="Product Image"
              src={
                item?.productPhoto?.docURL
                  ? item?.productPhoto?.docURL
                  : item?.productPhoto?.[0]?.docURL
              }
              width="40px"
              height="40px"
              sx={{
                objectFit: "contain",
                border: logoImgborder1,
                borderRadius: "7px",
                padding: "3px",
              }}
            />
            {/* <Box
              sx={{
                position: "relative",
                width: "40px",
                height: "40px",
                padding: "3px",
                backgroundColor: "#ffffff",
                alignItems: "center",
                textAlign: "center",
                borderRadius: "5px",
                border: "1px solid #e5e9f0",
                marginRight: "12px",
                display: "flex",
                justifyContent: "space-around",
              }}
            >
              <Box
                component="img"
                maxHeight={{ xs: "29px", md: "40px" }}
                src={item?.productPhoto?.[0]?.docURL}
                alt="CostBo"
              />
            </Box> */}
            <Typography
              variant="h3"
              fontSize={{ xs: 12, md: 12 }}
              color={blackShade19}
              fontWeight={600}
              lineHeight={1.5}
            >
              {item?.productName}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6} md={2}>
          <Typography variant="h5" sx={styles.mainText}>
            {item?.productMainCategory?.[0]?.ondcValue}
          </Typography>
          <Typography
            variant="h5"
            fontSize={11}
            fontWeight={400}
            color={bgColor15}
          >
            {item?.productSubCategory?.[0]?.ondcSubValue}
          </Typography>
        </Grid>{" "}
        <Grid item xs={6} md={1.3}>
          <Box
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              color:
                item.availability?.[0] == "Yes"
                  ? greenStatusColor01
                  : redStatusColor01,
              textAlign: "center",
              backgroundColor:
                item.availability?.[0] == "Yes"
                  ? lightgreenColor04
                  : redColor09,
              // padding: "2px 4px",
              width: "40px",
              borderRadius: "4px",
            }}
          >
            {item.availability?.[0] == "Yes" ? "Yes" : "No"}
          </Box>
        </Grid>
        {item?.catalogPartnerItemInfo?.length === 0 && (
          <Grid item xs={6} md={1.2}>
            <Typography variant="h5" sx={styles.mainText}>
              {item.availableQuantity}
            </Typography>
          </Grid>
        )}
        <Grid
          item
          xs={12}
          md={2.5}
          ml={item?.catalogPartnerItemInfo?.length === 0 ? 0 : 2}
        >
          <Box display={"flex"} gap={1}>
            {item?.productOriginalPrice !== item?.productSalePrice && (
              <Typography
                variant="h5"
                fontSize={12}
                fontWeight={500}
                color={bgColor15}
                sx={{ textDecoration: "line-through" }}
              >
                ₹ {addThousandsSeparator(item?.productOriginalPrice)}
              </Typography>
            )}

            <Typography variant="h5" sx={styles.mainText}>
              ₹ {addThousandsSeparator(item?.productSalePrice)}
            </Typography>
            <Typography
              variant="h5"
              fontSize={12}
              fontWeight={600}
              color={greenStatusColor01}
            >
              {item?.productOriginalPrice !== item?.productSalePrice
                ? `${getDiscountPercentage(
                    item?.productSalePrice,
                    item?.productOriginalPrice
                  )}%`
                : ""}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={1}>
          <Box
            sx={{
              fontWeight: 500,
              fontSize: "12px",
              color: orangeColor03,
              textAlign: "center",
              backgroundColor: lightOrange04,
              // padding: "2px 4px",
              width: "40px",
              borderRadius: "4px",
            }}
          >
            {item?.soldQuantity ? item?.soldQuantity : "-"}
          </Box>
        </Grid>
        {/* <Grid item xs={12} md={0.8}>
          <Box
            sx={styles.statusChip({
              bgColor: item?.variantInfo?.masterProductVariantId
                ? perpleBgColor11
                : bgColor11,
              color: blackShade19,
            })}
            onClick={() => {
              if (item?.variantInfo?.masterProductVariantId && item?.count > 0)
                handleViewChildVariants(item);
            }}
          >
            {item?.variantInfo?.masterProductVariantId
              ? item?.count || "XX"
              : "-"}
          </Box>
        </Grid> */}
      </Grid>
      {/* {JSON.stringify(item?.productinfo)} */}
    </Box>
  );
}

export default ProductDetailCatalogReport;

const styles = {
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    // borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    // position: "sticky",
    // top: 248,
    zIndex: 10000,
    // marginBottom: "15px",
  },
  mainText: {
    fontSize: "12px",
    color: blackShade19,
    fontWeight: 600,
    lineHeight: "16px",
    marginBottom: "0px",
    marginTop: "0px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  statusChip: (data) => ({
    backgroundColor: data.bgColor,
    color: data.color,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.5,
    p: "3px 16px",
    display: "flex",
    justifyContent: "center",
    borderRadius: "50px",
    width: "max-content",
    minWidth: "45px",
    cursor: data.bgColor === perpleBgColor11 ? "pointer" : "",
  }),
};
